import useGetPaymentGatewayPoint from "features/payment-gateway/hooks/useGetPaymentGatewayPoint";
import { useParams } from "react-router-dom";

export default function usePaymentGatewayOrganizationAddress(): string | undefined {
    const { tokenAddress } = useParams();
    const { data: point } = useGetPaymentGatewayPoint({ tokenAddress });
    return point?.organizationAddress;
}
